/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Core API
 * Core API Documentation
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  CreateFireDoorCommandControllerCreate201,
  CreateFireDoorDto,
  FireDoorResponseDto,
  ListFireDoorsQueryControllerListParams,
  UpdateFireDoorCommandControllerUpdate200,
  UpdateFireDoorDto,
} from "../model";

import { axiosClient } from "../../lib/api";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * @summary Register a fire door for a nursery
 */
export const createFireDoorCommandControllerCreate = (
  nurseryId: string,
  createFireDoorDto: CreateFireDoorDto,
  signal?: AbortSignal,
) => {
  return axiosClient<CreateFireDoorCommandControllerCreate201>({
    url: `/v1/nurseries/${nurseryId}/fire-doors`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createFireDoorDto,
    signal,
  });
};

export const getCreateFireDoorCommandControllerCreateMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createFireDoorCommandControllerCreate>>,
    TError,
    { nurseryId: string; data: CreateFireDoorDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createFireDoorCommandControllerCreate>>,
  TError,
  { nurseryId: string; data: CreateFireDoorDto },
  TContext
> => {
  const mutationKey = ["createFireDoorCommandControllerCreate"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createFireDoorCommandControllerCreate>>,
    { nurseryId: string; data: CreateFireDoorDto }
  > = (props) => {
    const { nurseryId, data } = props ?? {};

    return createFireDoorCommandControllerCreate(nurseryId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateFireDoorCommandControllerCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof createFireDoorCommandControllerCreate>>
>;
export type CreateFireDoorCommandControllerCreateMutationBody =
  CreateFireDoorDto;
export type CreateFireDoorCommandControllerCreateMutationError = void;

/**
 * @summary Register a fire door for a nursery
 */
export const useCreateFireDoorCommandControllerCreate = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createFireDoorCommandControllerCreate>>,
      TError,
      { nurseryId: string; data: CreateFireDoorDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createFireDoorCommandControllerCreate>>,
  TError,
  { nurseryId: string; data: CreateFireDoorDto },
  TContext
> => {
  return useMutation(
    getCreateFireDoorCommandControllerCreateMutationOptions(options),
    queryClient,
  );
};
/**
 * @summary List all fire doors for a nursery
 */
export const listFireDoorsQueryControllerList = (
  nurseryId: string,
  params?: ListFireDoorsQueryControllerListParams,
  signal?: AbortSignal,
) => {
  return axiosClient<FireDoorResponseDto[]>({
    url: `/v1/nurseries/${nurseryId}/fire-doors`,
    method: "GET",
    params,
    signal,
  });
};

export const getListFireDoorsQueryControllerListQueryKey = (
  nurseryId: string,
  params?: ListFireDoorsQueryControllerListParams,
) => {
  return [
    `/v1/nurseries/${nurseryId}/fire-doors`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListFireDoorsQueryControllerListQueryOptions = <
  TData = Awaited<ReturnType<typeof listFireDoorsQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  params?: ListFireDoorsQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listFireDoorsQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListFireDoorsQueryControllerListQueryKey(nurseryId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listFireDoorsQueryControllerList>>
  > = ({ signal }) =>
    listFireDoorsQueryControllerList(nurseryId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: nurseryId !== null && nurseryId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listFireDoorsQueryControllerList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListFireDoorsQueryControllerListQueryResult = NonNullable<
  Awaited<ReturnType<typeof listFireDoorsQueryControllerList>>
>;
export type ListFireDoorsQueryControllerListQueryError = void;

export function useListFireDoorsQueryControllerList<
  TData = Awaited<ReturnType<typeof listFireDoorsQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  params: undefined | ListFireDoorsQueryControllerListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listFireDoorsQueryControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listFireDoorsQueryControllerList>>,
          TError,
          Awaited<ReturnType<typeof listFireDoorsQueryControllerList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListFireDoorsQueryControllerList<
  TData = Awaited<ReturnType<typeof listFireDoorsQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  params?: ListFireDoorsQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listFireDoorsQueryControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listFireDoorsQueryControllerList>>,
          TError,
          Awaited<ReturnType<typeof listFireDoorsQueryControllerList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListFireDoorsQueryControllerList<
  TData = Awaited<ReturnType<typeof listFireDoorsQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  params?: ListFireDoorsQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listFireDoorsQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List all fire doors for a nursery
 */

export function useListFireDoorsQueryControllerList<
  TData = Awaited<ReturnType<typeof listFireDoorsQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  params?: ListFireDoorsQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listFireDoorsQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListFireDoorsQueryControllerListQueryOptions(
    nurseryId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update a fire door
 */
export const updateFireDoorCommandControllerUpdate = (
  nurseryId: string,
  fireDoorId: string,
  updateFireDoorDto: UpdateFireDoorDto,
  signal?: AbortSignal,
) => {
  return axiosClient<UpdateFireDoorCommandControllerUpdate200>({
    url: `/v1/nurseries/${nurseryId}/fire-doors/${fireDoorId}`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: updateFireDoorDto,
    signal,
  });
};

export const getUpdateFireDoorCommandControllerUpdateMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateFireDoorCommandControllerUpdate>>,
    TError,
    { nurseryId: string; fireDoorId: string; data: UpdateFireDoorDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateFireDoorCommandControllerUpdate>>,
  TError,
  { nurseryId: string; fireDoorId: string; data: UpdateFireDoorDto },
  TContext
> => {
  const mutationKey = ["updateFireDoorCommandControllerUpdate"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateFireDoorCommandControllerUpdate>>,
    { nurseryId: string; fireDoorId: string; data: UpdateFireDoorDto }
  > = (props) => {
    const { nurseryId, fireDoorId, data } = props ?? {};

    return updateFireDoorCommandControllerUpdate(nurseryId, fireDoorId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateFireDoorCommandControllerUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateFireDoorCommandControllerUpdate>>
>;
export type UpdateFireDoorCommandControllerUpdateMutationBody =
  UpdateFireDoorDto;
export type UpdateFireDoorCommandControllerUpdateMutationError = void;

/**
 * @summary Update a fire door
 */
export const useUpdateFireDoorCommandControllerUpdate = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateFireDoorCommandControllerUpdate>>,
      TError,
      { nurseryId: string; fireDoorId: string; data: UpdateFireDoorDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateFireDoorCommandControllerUpdate>>,
  TError,
  { nurseryId: string; fireDoorId: string; data: UpdateFireDoorDto },
  TContext
> => {
  return useMutation(
    getUpdateFireDoorCommandControllerUpdateMutationOptions(options),
    queryClient,
  );
};
